/* ============================================================
   UGOITA お知らせ（記事ページ）— 目次アプリの配色を記事のトーンに合わせる
   ------------------------------------------------------------
   🚨 なぜ JS が必要か（2026-08-20 実測）
   目次アプリ（RuffRuff / table-of-contents）は、自分の見た目を
   **インライン style + !important** で書き込む。実測値：
     ・箱（nav）      … background-color: #F7F9F9 !important（ほぼ白）／border: 1px #E4E4E4
     ・リンク・リスト … color: #6F7372 !important（暗いグレー）
   インラインの !important は**外部CSSからは上書き不能**（同一オリジンではstyle属性の
   詳細度が最強）ため、紺地（#0d1424）の記事本文で白い箱が浮き、文字も読みにくい。
   → 描画後に同じプロパティを「こちらのインライン !important」で上書きする。

   ★ アプリ管理画面で配色を設定できるようになったら、この処理は不要（このファイルの
     読み込みを外すだけでアプリ既定に戻る）。
   ★ 触るのは色だけ。目次の構造・見出しidの採番・スクロール挙動には一切手を入れない。
   ============================================================ */
(function () {
  var SEL = '[class*="ruffruff-table-of-contents"]';
  /* 目次に載せる見出しレベル。記事セクションが .ub-article[data-ub-toc] で指定する
     （'h2' … 見出し2だけ ／ それ以外 … アプリ既定のまま）。
     アプリ側の設定（headings: ["h2","h3","h4"]）を管理画面で h2 のみにできたら、この処理は不要。 */
  function tocMode() {
    var host = document.querySelector('[data-ub-toc]');
    return host ? (host.getAttribute('data-ub-toc') || '') : '';
  }
  var TONE = {
    box: 'rgba(255, 255, 255, 0.04)',   /* 紺地から浮かない、わずかに明るい面 */
    border: 'rgba(255, 255, 255, 0.14)',
    text: '#c3cbdd',                    /* --text-2 と同値 */
    heading: '#ffffff'                  /* --text と同値（「目次」ラベル用） */
  };

  function tune(toc) {
    if (!toc) return;
    var nodes = toc.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var st = el.getAttribute('style') || '';
      /* 明るい面を持っている要素だけ、面と枠線を差し替える */
      if (/background-color\s*:/i.test(st)) {
        el.style.setProperty('background-color', TONE.box, 'important');
        el.style.setProperty('border-color', TONE.border, 'important');
      }
      /* 文字色を持っている要素は本文と同じトーンへ */
      if (/(^|;)\s*color\s*:/i.test(st)) {
        el.style.setProperty('color', TONE.text, 'important');
      }
    }
    var links = toc.querySelectorAll('a');
    for (var j = 0; j < links.length; j++) {
      links[j].style.setProperty('color', TONE.text, 'important');
    }
    /* 見出し（「目次」など）は少し明るく */
    var head = toc.querySelector('[class*="title"], [class*="heading"]');
    if (head) head.style.setProperty('color', TONE.heading, 'important');
  }

  /* 見出し2だけの目次にする。項目は**消さずに隠す**（アプリ側のスクロール連動が
     ノードを参照している可能性があるため）。本文の見出しidには一切触らない。 */
  function h2only(toc) {
    if (!toc || tocMode() !== 'h2') return;
    var links = toc.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < links.length; i++) {
      var target = document.getElementById(links[i].getAttribute('href').slice(1));
      if (!target || target.tagName === 'H2') continue;
      var li = links[i].closest ? links[i].closest('li') : null;
      if (li) li.style.setProperty('display', 'none', 'important');
    }
    /* 中身が全部隠れた入れ子リストは、余白だけ残らないよう畳む */
    var lists = toc.querySelectorAll('ol, ul');
    for (var k = 0; k < lists.length; k++) {
      var kids = lists[k].children, shown = false;
      for (var m = 0; m < kids.length; m++) {
        if (getComputedStyle(kids[m]).display !== 'none') { shown = true; break; }
      }
      if (!shown) lists[k].style.setProperty('display', 'none', 'important');
    }
  }

  function run() {
    var toc = document.querySelector(SEL);
    tune(toc);
    h2only(toc);
  }

  run();

  /* アプリはクライアント側で後から挿入するので、挿入を待って一度だけ整える。
     監視するのは childList だけ（style属性の変更は監視しない＝自分の書き換えで無限ループしない）。
     30秒で監視を打ち切る（それまでに出ていなければ、その記事に見出しが無く目次が出ない）。 */
  if (typeof MutationObserver === 'function') {
    var ob = new MutationObserver(function () {
      var toc = document.querySelector(SEL);
      if (toc) { tune(toc); h2only(toc); }
    });
    ob.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { ob.disconnect(); }, 30000);
  }
})();
